import React from 'react';

interface CheckboxProps {
  label?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

export const Checkbox: React.FC<CheckboxProps> = ({ label, checked, onChange, disabled = false }) => {
  const handleToggle = () => {
    if (!disabled) {
      onChange(!checked);
    }
  };

  return (
    <label className={`inline-flex items-center cursor-pointer ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}>
      <div
        className={`relative w-5 h-5 flex items-center justify-center rounded-md border transition-all 
                    ${checked ? 'bg-primary border-primary' : 'bg-white border-gray-300'}
                    ${disabled ? 'bg-gray-200 border-gray-200' : ''}`}
        onClick={handleToggle}
      >
        {checked && (
          <svg
            className="w-5 h-5 text-white"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={3}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
          </svg>
        )}
      </div>
      {label &&
      <span className="ml-2 text-gray-700">{label}</span>  
    }
    </label>
  );
};

export default Checkbox;